import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { CasinoTheme } from '@frontend/casino-ui/shared';

import { PillItemComponent } from '../pill-item.component';
import { FixedItemNavigations, FixedNavIcons, FixedNavIds, FixedNavigationItem, PillSubNavConfig } from '../pills-sub-navigation.model';

@Component({
    selector: 'cc-fixed-navigation',
    standalone: true,
    templateUrl: './fixed-navigation.component.html',
    imports: [PillItemComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FixedNavigationComponent {
    config = input<PillSubNavConfig>({} as PillSubNavConfig);
    defaultPageText = input<{ url: string; text: string }>({ url: '', text: '' });
    currentTheme = input<CasinoTheme>('bwin');

    readonly goToUrl = output<string>();
    readonly goToPromotionPage = output<boolean>();
    readonly goToDefaultPage = output<string>();
    readonly showSearch = output<boolean>();

    readonly fixedNavItems = computed<FixedNavigationItem[]>(() => {
        const cfg: PillSubNavConfig = this.config();
        const pageText = this.defaultPageText();
        const defaultText = pageText?.text;
        return [
            {
                id: FixedNavIds.SEARCH,
                categoryname: cfg?.searchText,
                icon: FixedNavIcons.SEARCH,
                clickHandler: () => this.handleShowSearch(),
                condition: cfg?.showSearchInTopNavigation,
            },
            {
                id: FixedNavIds.HOME,
                categoryname: defaultText,
                icon: FixedNavIcons.BADGE,
                clickHandler: () => this.handleGoToDefaultPage(FixedItemNavigations.SHOWHOMEFIXEDNAVIGATION),
                condition: cfg?.showHomeFixedNavigation,
                url: cfg?.mcPageDefaultHomePageUrl,
            },
            {
                id: FixedNavIds.HOME_v2,
                categoryname: defaultText,
                icon: FixedNavIcons.BADGE,
                clickHandler: () => this.handleGoToDefaultPage(FixedItemNavigations.FIXEDNAVENABLED),
                condition: cfg?.fixednavEnabled && cfg?.showHomeInTopNavigation,
                url: cfg?.mcPageDefaultHomePageUrl,
            },
            {
                id: FixedNavIds.PROMOTION,
                categoryname: cfg?.promotionLinkText,
                icon: FixedNavIcons.BADGE,
                clickHandler: () => this.handleGoToPromotionPage(),
                condition: cfg?.isPromotionPagesEnabled,
            },
        ];
    });

    handleGoToUrl(url: string): void {
        this.goToUrl.emit(url);
    }

    handleGoToPromotionPage(): void {
        this.goToPromotionPage.emit(true);
    }

    handleGoToDefaultPage(source: string): void {
        this.goToDefaultPage.emit(source);
    }

    handleShowSearch(): void {
        this.showSearch.emit(true);
    }
}
